module.exports = __webpack_public_path__ + "img/blind_logo.df54032f.png";